import React, {useContext, useEffect, useState} from 'react';
import ReactEcharts from 'echarts-for-react';
import BaseReportBox, {LoadStatus} from "./BaseReportBox";
import {Report_getGenderCompetition} from "../../network/api/report.api";
import {ErrorContext} from "../../components/GympinPagesProvider";

const GympinMaleFemaleCompare = ({corporate}) => {

    const error = useContext(ErrorContext);
    const [competitionData,setCompetitionData] = useState(null);
    const [loadStatus,setLoadStatus] = useState(LoadStatus.LOADING);

    useEffect(() => {
        getGenderCompatition();
    }, []);



    function getGenderCompatition(){
        setLoadStatus(LoadStatus.LOADING);
        Report_getGenderCompetition({id:corporate?.Id}).then(result => {
            setCompetitionData(result.data.Data);
            if(result?.data?.Data?.UsesManInTotal||result?.data?.Data?.UsesWomanInTotal){
                setLoadStatus(LoadStatus.LOADED);
            }else{
                setLoadStatus(LoadStatus.NODATA);
            }

        })
            .catch(e => {
                try {
                    setLoadStatus(LoadStatus.ERROR);
                    error.showError({message: e.response.data.Message});
                } catch (f) {
                    error.showError({message: "خطا نا مشخص",});
                }
            });
    }


    const symbols = [
        'path://M463,3834.1c-11.5-93.7-45.8-391.5-55.8-485.4c-1.2-10.9-4.8-16.2-16.8-15.5c-16.1,1-32.3-0.6-48.3,0.6\n' +
        '\tc-13.1,1-17-3.3-16.7-16.2c1.7-86.9,1.5-173.8,4.4-260.6c5.4-164.5,16-328.8,26.6-493.1c1-16-3.6-16.7-17.2-12.9\n' +
        '\tc-45.3,12.9-91.3,21.4-138.8,17.7c-20.3-1.6-40.2-5.3-59.7-10.8c-39.9-11.2-64.3-38-76.1-77c-3-10-6-20.5-6.2-30.8\n' +
        '\tc-1-45.8-7.5-86.6-38.6-126.4c-30.7-39.3-22.5-89.8,2.6-133.2c26.8-46.4,67.5-76.3,120-88.4c16.9-3.9,29.5-10,40.9-24.5\n' +
        '\tc17.4-22.1,34.7-46.1,64.7-54.3c3.9-1.1,6.8-6.7,9.7-10.5c22.4-28.7,42.8-59.2,74.4-79.1c7.1-4.5,7.4-11.4,7.7-18.4\n' +
        '\tc3.5-77.4,32.3-147,66.9-214.7c31.6-61.8,67.7-121,105.6-179c59.1-90.4,101.6-190.2,159.6-281.1c1.4-2.3,2.9-4.5,7.4-11.4\n' +
        '\tc0,35.6,0,65.3,0,96.7c39.2-40.6,77.3-81.3,118.3-118.9c93-85.4,197-152.5,319.7-186.7c36.1-10,29.9-11,34.1,22\n' +
        '\tc11.8,91.7,50.1,174.5,84,258.5c75.7,187.4,88.8,379,42.1,574.6c-21.6,90.5-32.2,158.4-67.6,254.6c-32.1,94.7-35.4,154.7-40.9,264\n' +
        '\tc-6.4,126.5-6.2,174.9,3.8,311.4c11,138.9,12.7,282.7,36.2,419.4c23.7,79,43.8,158.9,60,240.5c-3.8,0.5-6.5,1.1-9.2,1.2\n' +
        '\tc-37.1,1-38,0.9-43.5,36.4c-14.2,90.8-74,342.3-97.4,430.8 M148.6,2260.5c36.2-26.6,75.3-43.2,107.8-70.1c3.7-3.1,7.3-3.2,11.6-2.8\n' +
        '\tc25.9,2.3,50.5,6.3,71.8,24.6c14,12.1,32.3,19.4,48.7,28.7c10.3,5.8,21.3,6.4,32.6,4.3c5.6-1,11.7-2.6,13.6-8.3\n' +
        '\tc2.1-6.2-3.1-10.6-7.4-13.8c-41.7-30.8-75.6-73.8-130.9-83.3c-3.8-0.7-7.3-3.6-10.9-5.5c2.3-3.3-5.3-11.7,4-10.6\n' +
        '\tc29.7,3.3,61.3-5.3,87.3,20c26.5,25.8,55.9,48.7,86.6,69.7c10.3,7.1,21.6,13.5,35.2,10.5c8.4-1.9,16.6-5.4,20.4-13.2\n' +
        '\tc4.6-9.4-5-14-10.1-18.5c-27.1-24.3-55.8-46.9-82.2-71.9c-32.1-30.3-67.3-51.6-112.9-51c-4.1,0-9.2,1-13.4-3.9\n' +
        '\tc30.3-8.5,60.5-13.6,90.6-19.3c10-1.9,17.1-0.6,25.1,5.1c33.8,23.7,67.9,46.9,102,70.1c14.3,9.7,31.8,11,42.5-1\n' +
        '\tc11.8-13.2-3.9-24.1-12.6-33c-32.3-33.3-68.9-61.4-107.7-86.9c-9.4-6.1-18.3-9.5-29.3-8.2c-15.2,1.8-30.4,3-50.5,4.9\n' +
        '\tc26.2-18.9,47.1-35.6,61.8-57.9c8-12.2,17.6-15.3,30.6-17.4c29.6-4.8,60-6.1,88.6-16.1c13-4.6,27.5-13.4,25.5-26.9\n' +
        '\tc-1.9-12.8-19.1-11.1-30.5-11.4c-38.6-1.1-76.6,6.7-114.8,10.5c-4.8,0.5-9.5,2-12.9,6.2c-39.5,48.2-86.4,90-126,137.7\n' +
        '\tc-40.1,48.3-72.8,102.7-112.8,151.5C149.8,2197.7,143.8,2226.4,148.6,2260.5z M78.4,2270.5c25.5-45.2,48.7-91.5,84.4-129.6\n' +
        '\tC113.9,2170.5,79,2209.4,78.4,2270.5z M346,289.1c10.3-9.6,6.8-22.1,6.9-33.6c0.6-81.8,61.9-157,146.3-175.2\n' +
        '\tc-17.5,11.6-32.3,21.7-38.5,39.5c-6.4,18.4-3.4,35.1,9.4,52.8c10.4-47.5,44.2-66.8,88.2-80.4c-9.4,12.4-19.9,19.9-21.7,33.1\n' +
        '\tc-0.8,6,0,12.2,3.8,15.4c4.9,4.1,8.3-2.8,11.9-5.3c23.9-17,52.8-21.4,78.8-33.3c2.3,7.1-6.6,7.6-6.1,15.5\n' +
        '\tc40.7-6.2,81.3-13.1,120.7-26C796.3,74.9,847.1,59,906.3,64.8c-44.6,6.5-84.7,12.4-120,35.3c19.6-4.8,39.1-10.2,58.9-14.3\n' +
        '\tc46.4-9.5,93-12.7,139,2c50.1,16,84.8,47.6,96.4,100.7c1.4,6.6,2.8,11.4,10.7,13.3c116.4,28,149.8,141.9,133.8,238.8\n' +
        '\tc-3.5-75.9-17.4-142.3-73.6-191.5c18.5,24.5,36.1,49.8,46.2,79.2c31,89.9,22,179-5.4,267.8c-15.6,50.9-42.8,97.5-55,149.5\n' +
        '\tc-7.1,30.4-13.3,61.1-22.9,91.3c0-14.4,0-28.9,0-43.3c-8.4,21.1-6.9,46-20.6,63.2c-21.3,26.7-13.7,54-8.5,81.6\n' +
        '\tc2.5,13.1,0.5,17.3-13.6,20.6c-116.9,28.1-222.6,78.5-311.9,160.5c-7.1,6.6-13.9,13.5-22.3,21.6c-10.2-45.3-19.7-89.9-30.3-134.2\n' +
        '\tc-10.5-43.7-6-37.6-45.4-25.1c-28.7,9.1-56.8,19.6-86.5,25.3c-45.9,8.8-74.4-15.8-69.6-62.3c2.4-23,2.6-43.5-19.8-57.1\n' +
        '\tc-1.2-0.7-3-2.2-2.9-2.9c5.1-20.9-17.1-33.8-15.2-54.5c3.1-32.8-6.1-43.3-38.8-49.7c-31-6-35-15.5-19.7-42.7\n' +
        '\tc18.9-33.5,36.6-67.7,55.6-101.2c8.4-14.8,9.2-27.4-4.5-39.1c-17.2-14.6-17.7-32.5-12.5-53.1c11.8-46.1,22.1-92.5,20.1-140.8\n' +
        '\tc-0.5-12.7-3.8-18.1-16.6-16.7c-4.8,0.5-9.8-0.2-14.7-0.4c-51.8-2.5-76.9-22.9-91.9-78.9c8.6,13.1,13.8,22,19.9,30.2\n' +
        '\tc6.2,8.3,13.9,15.1,24.9,17.8c-19.1-19.7-27-46.1-43.5-67.1L346,289.1z M843.7,97.2c61.8-4.9,120.9,5.8,176.4,35.4\n' +
        '\tC967.3,90.4,908.6,78.2,843.7,97.2z',
        'path://M850.5,3272.2c-1.8,0-3.7,0-5.5,0 M223,3548.5c-10.2-40-84.1-417.8-88.4-458.9c-1.5-14.5-5.9-23.7-22.6-21.8\n' +
        '\t\t\tc-17.9,2-10.8-11-9.2-18c10.8-47.1,11.7-82.6,19.5-140.1c19.5-153,87.8-277.8,157.5-408.1c72.2-134.9,74-270.7,24.5-411.9\n' +
        '\t\t\tc-35-99.9-56.5-191.3-108.9-282.3c-84.1-145.9-119.9-302.4-106.1-469.9c8.6-105.6,39.9-204.1,96.5-294.3\n' +
        '\t\t\tc18.3-29.2,36.7-57.8,43.2-93.8c4.9-27.5,21.9-52.7,32.6-79.3c5.3-13.2,10.9-15.9,24.6-9.4c50.9,24.2,97.4,55.1,142.7,88.1\n' +
        '\t\t\tc116.4,84.9,211.9,191.3,304.2,300.5c81.7,96.8,161.8,195.1,227.2,304.3c50,83.4,72.9,173.2,62.8,272.7\n' +
        '\t\t\tc-24.9-17.2-44.4-37.3-60.7-60.9c-16.2-23.7-33-47-49.7-70.3c-8.2-11.5-18.9-17.3-33.8-17.2c-34.3,0.1-68.3-7.6-102.7-4\n' +
        '\t\t\tc-11.9,1.3-29.8-0.4-31.2,13.7c-1.3,12.9,15.2,19.6,27.2,22.4c32.7,7.6,66.1,11.1,99.6,12.8c11.4,0.6,19.9,2.8,27.3,11.7\n' +
        '\t\t\tc21.9,26.4,41.5,54.3,61.8,86.7c-23.7,0-44.9,0.1-66.1,0c-8.6-0.1-16.5,0.9-23.2,7.4c-31.2,30.3-62.8,60.2-87,96.6\n' +
        '\t\t\tc-4.7,7.1-14.3,15.2-6.6,24c8,9.1,20.5,8.9,31.3,4.3c10.9-4.7,20-12.7,28.7-21c11.6-11.2,25.1-20.8,34.8-33.4\n' +
        '\t\t\tc33.6-43.3,75.9-24,119.4-20.1c-8.6,12-19.4,11.7-27.9,12.7c-21,2.4-35.6,12.8-49,28.5c-25.9,30.3-54.5,58.4-76.8,91.7\n' +
        '\t\t\tc-4.2,6.2-14.2,13.3-6.3,21.6c6.4,6.7,16.3,6.2,25.8,3.5c8.7-2.5,14.3-8.6,20.2-14.4c23.1-22.4,46.1-45,69.3-67.3\n' +
        '\t\t\tc19.2-18.5,56.7-23.3,82.7-11.2c0.1,4.4-3,5.7-6.5,6.6c-52.3,13.7-79.4,56.9-110.8,95c-7.8,9.5-4.4,15,7.6,16.2\n' +
        '\t\t\tc11,1.1,20.9-1.5,29.7-7.9c13.6-9.9,28.4-18.7,40-30.5c16.5-16.9,36.6-21.5,58.5-24.1c8.1-0.9,13,4.1,18.7,7.6\n' +
        '\t\t\tc27.4,16.8,54.7,33.7,84.2,52c-2-31.1-12.8-56.3-30.7-78.9c-23.9-30.1-45.5-61.6-61.4-101.6c17.2,13.8,25.7,29.6,36,43.6\n' +
        '\t\t\tc7.6,10.3,16,15.3,29.1,17.2c88.3,12.4,152.4,84.3,149.7,166.9c-0.9,27.9-8.5,54.1-26.1,76.1c-8.9,11.1-12.6,22.4-11.4,36.6\n' +
        '\t\t\tc1.6,19.6-0.7,39.1-4,58.5c-11.3,65.4-40.9,91.3-107.8,94.1c-40.8,1.8-81.2-2.6-121.4-8.6c-15.3-2.3-21.5-0.4-20,18.6\n' +
        '\t\t\tc16.1,208.9,28.5,417.9,26.5,627.6c-0.3,30.5,3.6,26.4-27.1,26.4c-53.9,0-55.3,459.8-60.1,513 M1213.6,2108.5\n' +
        '\t\t\tc-2.6-47.1-22.2-85.8-58.7-116C1181,2027.8,1198.4,2067.5,1213.6,2108.5z M584.9,1013.6c-29.9-27.5-57.8-54.8-87.4-80\n' +
        '\t\t\tc-47-40.2-98.2-74.4-153.4-102.5c-11.1-5.6-14.8-11.8-11.2-24.4c8-27.5,13.3-55.8,21.6-83.2c6-19.8,3-34.5-10.5-51.3\n' +
        '\t\t\tC283,595.9,241,510.8,229.6,412.4c-4.3-37.2-2.9-74.1,4-110.8c0.8-4.1,1.3-8.3,2.2-12.4c3-13.3-5.3-19.8-15.6-23.7\n' +
        '\t\t\tc-10.5-4-17.2,2.9-22.3,11.1c-11.1,18.1-12.3,38.5-12.1,58.9c0.6,57.1,14.1,112.3,26.6,167.6c22.2,98,39,196.4,27.4,297.5\n' +
        '\t\t\tc-4.3,37.5-12.7,74-28.1,108.9c5.2-49.3,11.2-98.5,1.5-148.3c-1.6,97.8-32.3,186.6-81,270.2c9.4-47.3,27.3-92.9,31.2-145.6\n' +
        '\t\t\tc-38.3,95.9-87.4,184.7-73.5,291c-73.3-151.8-64.5-311.8-62.5-471.3C18.5,757.9,12.8,810,11.9,862.8c-8.7-45.1-6-90.4-3.8-135.7\n' +
        '\t\t\tc3.6-71.6-0.5-142.8-5.8-214.1c-6.2-83.2-2-165.4,32.6-243.1c25-56.1,60.9-100.8,126.1-112c31.1-5.3,61.9-1.8,90.9,9.1\n' +
        '\t\t\tc15.9,6,24.8,3.2,35.4-9.1c49.1-57,108.2-99.8,182.1-118.1c141.3-34.9,270.7-9.7,385.8,80.7c26.8,21,54.3,46.8,53.6,81.9\n' +
        '\t\t\tc-1,49.9,20.4,94.9,22.2,143.7c1.7,47.4,0.7,93.7-21.6,137.2c-10,19.5-8.3,38.6,1.8,58.2c14.5,28.2,32.3,54,50.4,79.8\n' +
        '\t\t\tc14.1,20,12.3,25.2-10.7,35.5c-3.2,1.4-6.5,2.6-9.8,3.8c-36.9,13.3-36.9,13.3-31.1,51.4c0.3,2,1.6,5.5,1,5.9\n' +
        '\t\t\tc-18.5,10.4-13.4,36.2-28.4,46.4c-17.4,11.8-23.1,26.2-24.3,45.5c-2.8,45.1-26.1,59.9-69,44.9c-31.1-10.9-60.3-26.2-90.1-40.1\n' +
        '\t\t\tc-31.4-14.6-42.8-11-58.6,20.2c-20.3,40.2-31.3,83.8-43,127C593.1,978.5,589.3,995.4,584.9,1013.6z',
    ];
    const labelSetting = {
        show: true,
        position: 'top',
        offset: [0, 0],
        formatter: function (param) {
            return (param.value).toFixed(0) + '%';
        },
        fontSize: 20,
        fontFamily: 'IRANSans-web'
    };
    const markLineSetting = {
        symbol: 'none',
        lineStyle: {
            opacity: 0.3
        },
        data: [
            {
                type: 'max',
                label: {
                    formatter: '{c} درصد'
                }
            },
            {
                type: 'min',
                label: {
                    formatter: '{c} درصد'
                }
            }
        ]
    };
    const option = {
        tooltip: {},
        legend: {
            data: ['30 روز', 'کلی'],
            selectedMode: 'single'
        },
        xAxis: {
            data: [ 'درصد ورزش آقایان','درصد ورزش خانم‌ها'],
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: { show: false }
        },
        yAxis: {
            max: 100,
            offset: 10,
            splitLine: { show: false }
        },
        grid: {
            top: 'center',
            height: 350
        },
        markLine: {
            z: -100
        },
        series: [
            {
                name: '30 روز',
                type: 'pictorialBar',
                symbolClip: true,
                symbolBoundingData: 100,
                label: labelSetting,
                data: [
                    {
                        value: competitionData?.UsesManInMonth,
                        symbol: symbols[0]
                    },
                    {
                        value: competitionData?.UsesWomanInMonth,
                        symbol: symbols[1]
                    }
                ],
                markLine: markLineSetting,
                z: 10
            },
            {
                name: 'کلی',
                type: 'pictorialBar',
                symbolClip: true,
                symbolBoundingData: 100,
                label: labelSetting,
                data: [
                    {
                        value: competitionData?.UsesManInTotal,
                        symbol: symbols[0]
                    },
                    {
                        value: competitionData?.UsesWomanInTotal,
                        symbol: symbols[1]
                    }
                ],
                markLine: markLineSetting,
                z: 10
            },
            {
                name: 'full',
                type: 'pictorialBar',
                symbolBoundingData: 100,
                animationDuration: 0,
                itemStyle: {
                    color: '#ccc'
                },
                data: [
                    {
                        value: 0,
                        symbol: symbols[0]
                    },
                    {
                        value: 0,
                        symbol: symbols[1]
                    }
                ]
            }
        ]
    };

    return (

        <BaseReportBox title={"نسبت ورزش خانم‌ها به آقایان"} loadStatus={loadStatus} ReloadData={getGenderCompatition}>
            <ReactEcharts option={option} style={{ height: '400px', width: '100%' }} />
        </BaseReportBox>
    );
};

export default GympinMaleFemaleCompare;
